import { useNavigate } from 'react-router-dom'
import { Trash2 } from 'lucide-react'
import { Button } from '@teach/ui'
import { formatDate } from '@/lib/formatDate'
import type { Instruction } from '@/features/instructions/types'
import { useMessages } from '@/i18n'
import { messages } from './messages'

const ACCESS_KEYS = {
  private: 'accessPrivate',
  link: 'accessLink',
  public: 'accessPublic',
} as const

const accessKey = (type: string) =>
  Object.prototype.hasOwnProperty.call(ACCESS_KEYS, type)
    ? ACCESS_KEYS[type as keyof typeof ACCESS_KEYS]
    : null

interface Props {
  instruction: Instruction
  onDelete: (instruction: Instruction) => void
}

export const InstructionRow = ({ instruction, onDelete }: Props) => {
  const navigate = useNavigate()
  const m = useMessages(messages)
  const access = accessKey(instruction.accessType)
  return (
    <tr
      onClick={() => navigate(`/instructions/${instruction.slug}`)}
      className="border-b border-border last:border-0 hover:bg-muted/30 transition-colors cursor-pointer"
    >
      <td className="px-4 py-3 font-medium">
        {instruction.title || <span className="text-muted-foreground italic">{m.untitled}</span>}
      </td>
      <td className="px-4 py-3 text-muted-foreground">{instruction.author?.name ?? '—'}</td>
      <td className="px-4 py-3">
        <span className="text-xs text-muted-foreground">
          {access ? m[access] : instruction.accessType}
        </span>
      </td>
      <td className="px-4 py-3 text-muted-foreground">
        {instruction.updatedAt ? formatDate(instruction.updatedAt) : '—'}
      </td>
      <td className="px-2 py-3">
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 text-muted-foreground hover:text-destructive"
          onClick={(e) => {
            e.stopPropagation()
            onDelete(instruction)
          }}
        >
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      </td>
    </tr>
  )
}
